import { render, staticRenderFns } from "./Institucional.vue?vue&type=template&id=146db23c&"
import script from "./Institucional.vue?vue&type=script&lang=js&"
export * from "./Institucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports